<template>
  <div>
    <vxe-grid
      auto-resize
      ref="vxeGrid"
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :height="tableHeight"
      size="mini"
      :loading="loading"
      resizable
      border
      :expand-config="{ reserve: true }"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div
            style="display: flex;justify-content: space-between; align-items: center;"
          >
            <div>
              <span class="mr-3" style="font-size: 16px; color: #99A1B7">{{
                '报工日期:'
              }}</span>
              <el-date-picker
                v-model="localReportDate"
                type="date"
                size="mini"
                style="width: 200px;"
                placeholder="选择报工日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                @change="updateReportDate"
                :disabled="disabled"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </div>

            <b-button
              v-if="!disabled && fillMethoDis"
              class="mr-2"
              size="sm"
              :disabled="disabled"
              variant="outline-success"
              @click="openChooseGoods()"
              >{{ '添加报工人员' }}
            </b-button>
          </div>

          <!-- <b-button
              class="mr-2"
              size="sm"
              variant="outline-danger"
              @click="batchDel()"
              :disabled="disabled"
            
              <i class="el-icon-delete" />
              {{ $l('INDEX.btn_delete') || '删除' }}
            </b-button> -->
        </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            v-if="!disabled"
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:userName="{ row }">
        {{ row.userNo ? `${row.userName}（${row.userNo}）` : row.userName }}
      </template>
    </vxe-grid>
    <ChooseUser
      :visible.sync="userDialogVisible"
      :title="'报工人员信息'"
      @confirm="userConfirm"
      type="checkbox"
    />
  </div>
</template>
<script>
import ChooseUser from './choose-user/dialog.vue'
import { cloneDeep } from 'lodash'
export default {
  mixins: [],
  components: { ChooseUser },
  props: {
    disabled: { type: Boolean, default: false },
    fillMethoDis: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    userList: { type: Array, default: () => [] },
    v_createTime: { type: String, default: '' },
    reportDate: { type: String, default: '' },
  },
  watch: {
    userList: {
      handler() {
        this.tableData = cloneDeep(this.userList || [])
      },
      immediate: true,
    },
    reportDate: {
      handler(newVal) {
        // 将字符串转换为 Date 对象，如果无效则设为 null
        this.localReportDate = newVal ? new Date(newVal) : null
        if (this.localReportDate && isNaN(this.localReportDate.getTime())) {
          this.localReportDate = null
        }
      },
      immediate: true,
    },
  },
  computed: {
    tableColumns() {
      return [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          align: 'center',
          width: 60,
          slots: {
            default: 'opt',
          },
          visible: !this.disabled && this.fillMethoDis,
        },
        {
          title: this.$l('table_label_detail_userName') || '质检人员',
          field: 'userName',
          minWidth: 100,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          slots: { default: 'userName' },
        },
      ]
    },
  },
  data() {
    return {
      tableHeight: 250,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableData: [],
      userDialogVisible: false,
      localReportDate: null, // 初始化为 null
      pickerOptions: {
        disabledDate(time) {
          const today = new Date()
          today.setHours(0, 0, 0, 0)
          const oneWeekAgo = new Date(today)
          oneWeekAgo.setDate(today.getDate() - 7)
          // 禁用今天之后的日期和一周之前的日期
          return time.getTime() > today.getTime() || time.getTime() < oneWeekAgo.getTime()
        },
      },
    }
  },
  methods: {
    getTableData() {
      return this.tableData
    },
    openChooseGoods() {
      this.userDialogVisible = true
    },
    userConfirm(data) {
      this.$emit('chooseUserConfirm', data)
    },
    // 批量删除
    batchDel() {
      const data = this.getCheckboxRecords()
      if (!data || !data.length) return

      this.$confirm('您确定要删除所勾选数据吗?').then((type) => {
        if (type === 'confirm') {
          this.$refs.vxeGrid.removeCheckboxRow()
          data.forEach((item) => {
            this.tableData.forEach((row, index) => {
              if (row.userNo === item.userNo) {
                this.tableData.splice(index, 1)
              }
            })
          })
        }
      })
    },
    //单行删除
    del(row) {
      let index = this.$refs.vxeGrid.getRowIndex(row)
      this.$emit('del', index)
    },
    getCheckboxRecords() {
      const data = this.$refs.vxeGrid.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          message: this.$l('INDEX.tips_select_data') || '请选择需要操作的数据',
          type: 'warning',
        })
        return
      }
      return data
    },
    updateReportDate(value) {
      // value 是 yyyy-MM-dd 格式的字符串或 null
      const stringValue = value || ''
      this.localReportDate = value ? new Date(value) : null
      this.$emit('update:reportDate', stringValue)
    },
  },
}
</script>
